// can be used later when we have the same icons everywhere:
// export type Icon = keyof typeof Icons;

export type FlexDirection = keyof typeof flexDirections;
export type FlexAlign = keyof typeof flexAlign;
export type FlexJustify = keyof typeof flexJustify;
export type TextAlignment = keyof typeof textAlignments;
export type Gap = keyof typeof gaps;
export type ColSpan = 1 | 2 | 3 | 4 | 6 | 8 | 9 | 10 | 12;
export type Scale = "xs" | "sm" | "base" | "lg" | "xl" | "2xl" | "3xl";

export const textAlignments = {
	left: "text-left",
	center: "text-center",
	right: "text-right",
	start: "text-start",
	end: "text-end",
	justify: "text-justify",
} as const;

export const fontStyles = {
	italic: "italic",
	normal: "not-italic",
} as const;

export const flexDirections = {
	row: "flex-row",
	col: "flex-col",
} as const;

export const flexJustify = {
	start: "justify-start",
	end: "justify-end",
	center: "justify-center",
	between: "justify-between",
} as const;

export const flexAlign = {
	start: "items-start",
	end: "items-end",
	center: "items-center",
} as const;

export const gaps = {
	0: "gap-0",
	1: "gap-1",
	2: "gap-2",
	4: "gap-4",
	6: "gap-6",
	8: "gap-8",
	10: "gap-10",
	12: "gap-12",
} as const;

export const paddings: Record<Scale, `p-${number}`> = {
	xs: "p-1",
	sm: "p-2",
	base: "p-5",
	lg: "p-6",
	xl: "p-8",
	"2xl": "p-10",
	"3xl": "p-12",
};
